import { Injectable } from '@angular/core';
import { LoadingController, AlertController, ToastController } from '@ionic/angular';
import * as moment from "moment";
// import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { Router } from '../../node_modules/@angular/router';



@Injectable({
  providedIn: 'root'
})
export class GenericService {
  loadingPopup = null;
  buttonTextList = {
    OK: 'Okay',
    Cancel: 'Cancel',
    Sure: 'Sure',
    Dismiss: 'Dismiss'
  };

  requestTypeList = {
    GET: 1,
    POST: 2
  };
  requestType = Object.freeze(Object.assign({}, this.requestTypeList));
  loaderMessagesList = {
    fetch: 'Please wait while we populate the list...',
    authenticate: 'Authenticating.. Please wait..'
  };


  constructor(private loadingController: LoadingController, 
    private alertController: AlertController, private toastController: ToastController, 
   // private ga: GoogleAnalytics, 
    private router: Router) { }

  async presentAlert(header, message, subHeader?) {
    const alert = await this.alertController.create({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  async presentToast(message) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }

  async presentLoading(message) {
    const loading = await this.loadingController.create({
      message: message,
      duration: 10000
    });
    await loading.present();
    const { role, data } = await loading.onDidDismiss();
    //console.log('Loading dismissed!');
  }

  async hideLoader() {
    const loading = await this.loadingController.getTop();
    loading.dismiss();
  }


  getFormattedDate(date: Date, requiredFormat: string, currentFormat?) {
    if (currentFormat) {
      return moment(date, currentFormat).format(requiredFormat).toString();
    } else {
      return moment(date).format(requiredFormat).toString();
    }
  }

  async presentAlertMultipleButtons() {
    const alert = await this.alertController.create({
      header: 'Thanks!',
      message: 'We would like to serve you better. Please visit http://www.heromotocorp.com',
      buttons: ['Visit', 'No thanks']
    });

    await alert.present();
  }

  // googleAnalytics(){
  //   this.ga.startTrackerWithId('UA-110162237-9')
  //  .then(() => {
  //    //console.log('Google analytics is ready now');
  //     this.ga.trackView('test');
  //    // Tracker is ready
  //    // You can now track pages or set additional information such as AppVersion or UserId
  //  })
  //  .catch(e => console.log('Error starting GoogleAnalytics', e));
  // }
  // googleAnalyticsInitialise(category?,action?,label?){
  //   this.ga.startTrackerWithId('UA-110162237-9',5)
  
  //  .then(() => {
  //    console.log('Google analytics is ready now');
  //     this.ga.trackView('SelfJC');
  //    // Tracker is ready
  //    // You can now track pages or set additional information such as AppVersion or UserId
  //  })
  //  .catch(e => console.log('Error starting GoogleAnalytics', e));
  
  // }

  // googleAnalyticsTrackView(page?){
  //   console.log('trackview');
  //   this.ga.trackView('List Page')
  //   .then(() => {})
  //   .catch(e => console.log(e));
  // }

  // googleAnalyticsTrack(category?,action?,label?){

  //   this.ga.trackEvent(category, action, label)
  //  .then(() => {
  //    console.log('Google tracking is ready now');
  //    // this.ga.trackView('test');
  //    // Tracker is ready
  //  })
  //  .catch(e => console.log('Error starting GoogleAnalytics', e));
  // }

  async presentExitAlert(headerText?) {
    const alert = await this.alertController.create({
      header: headerText?headerText:'Server Error!',
      message: 'Please try after sometime',
      buttons: [
        {
          text: 'Ok',
          handler: () => { //takes the data 
            // this.router.navigate(['login']);
          }
        }
      ],
      backdropDismiss: false
    });
    await alert.present();
  }
}
